(ns frontend.ui.component.lp-portal.landing-page.report-preview-mobile.view
  (:require
   [frontend.ui.component.lp-portal.landing-page.report-preview-mobile.style :as style]
   [herb.core :refer [<class]]
   [frontend.ui.page.lp-portal.landing-page.event :as event]
   [frontend.ui.page.lp-portal.report.util :as ru]
   [re-frame.core :as rf]
   [common.util :as cu]))

(defn field
  [{:keys [title] :as props} & children]
  [:div
   {:class (<class style/field)}
   [:div
    {:class (<class style/field-title)}
    title]
   [:div
    {:class (<class style/field-value)}
    children]])

(defn report-preview-mobile
  [landing-page-commitment on-click]
  (fn []
    [:div
     {:class    (<class style/container)
      :on-click on-click}
     [:div
      {:class (<class style/fund-name)}
      (get-in landing-page-commitment [:fund-name])]

     [field
      {:title "Reference date"}
      (ru/->date-dd-MM-yyyy (get-in landing-page-commitment [:reference-date]))]
     [field
      {:title "Commitment EUR"}
      (ru/->int
       (get-in landing-page-commitment
               [:lp-commitment :lp-report-investor-commitment/data :commitment]))]

     (when (:feeder? landing-page-commitment)
       [field
        {:title "Stake %"}
        (ru/->percent-1-decimal
         (get-in landing-page-commitment
                 [:lp-commitment :lp-report-investor-commitment/data :stake-pct]))])

     [field
      {:title "Paid in"}
      (ru/->percent-1-decimal (get-in landing-page-commitment
                                      [:lp-commitment :lp-report-investor-commitment/data
                                       :paid-in-capital-pct]))]
     [field
      {:title "NAV (EUR)"}
      (ru/->int
       (get-in landing-page-commitment
               [:lp-commitment :lp-report-investor-commitment/data :fair-value]))]
     [field
      {:title "TVPI"}
      (ru/->multiple
       (get-in landing-page-commitment [:lp-commitment :lp-report-investor-commitment/data :tvpi]))]
     [field
      {:title "Net IRR"}
      (ru/->percent-1-decimal (get-in landing-page-commitment
                                      [:lp-commitment :lp-report-investor-commitment/data
                                       :net-irr]))]
     #_[field
        {:title "Total return LTM"}
        (ru/->percent-1-decimal (get-in landing-page-commitment
                                        [:lp-commitment :lp-report-investor-commitment/data
                                         :total-return-year-to-date]))]
    ]))
